
import { useState } from "react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Save, X, Loader2 } from "lucide-react";

interface FAQEditFormProps {
  question: string;
  answer: string;
  isLoading: boolean;
  onSave: (question: string, answer: string) => void;
  onCancel: () => void;
}

export const FAQEditForm = ({ question, answer, isLoading, onSave, onCancel }: FAQEditFormProps) => {
  const [editQuestion, setEditQuestion] = useState(question);
  const [editAnswer, setEditAnswer] = useState(answer);

  const handleSave = () => {
    onSave(editQuestion.trim(), editAnswer.trim());
  };

  return (
    <div className="space-y-4 pt-2">
      <div>
        <label className="block text-sm font-medium text-foreground mb-2">Question</label>
        <Input
          value={editQuestion}
          onChange={(e) => setEditQuestion(e.target.value)}
          disabled={isLoading}
          className="text-base min-h-[44px]"
        />
      </div>
      <div>
        <label className="block text-sm font-medium text-foreground mb-2">Answer</label>
        <Textarea
          value={editAnswer}
          onChange={(e) => setEditAnswer(e.target.value)}
          disabled={isLoading}
          rows={6}
          className="text-base leading-relaxed min-h-[120px] resize-none"
        />
      </div>
      <div className="flex flex-col sm:flex-row gap-3 sm:gap-2">
        <Button
          onClick={handleSave}
          disabled={isLoading}
          className="min-h-[44px] text-base"
        >
          {isLoading ? (
            <>
              <Loader2 className="h-4 w-4 mr-2 animate-spin" />
              Saving...
            </>
          ) : (
            <>
              <Save className="h-4 w-4 mr-2" />
              Save Changes
            </>
          )}
        </Button>
        <Button
          variant="outline"
          onClick={onCancel}
          disabled={isLoading}
          className="min-h-[44px] text-base"
        >
          <X className="h-4 w-4 mr-2" />
          Cancel
        </Button>
      </div>
    </div>
  );
};
